import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=04aba75f";
import script from "./upload-file.vue?vue&type=script&lang=jsx";
export * from "./upload-file.vue?vue&type=script&lang=jsx";
import style0 from "./upload-file.vue?vue&type=style&index=0&id=04aba75f&prod&lang=less";

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;